import { FolderPatternParams, GdriveParams, MetadataParams } from "./data-types-search-page";

export class LatestInputState {
  folderPatternInput: FolderPatternParams;
  gdriveInput: GdriveParams;
  metadataInput: MetadataParams;

  public constructor(
    aFolderPattern: FolderPatternParams,
    aGdrive: GdriveParams,
    aMetadata: MetadataParams
  ) {
    this.metadataInput = aMetadata;
    this.gdriveInput = aGdrive;
    this.folderPatternInput = aFolderPattern;
  }
}

export const emptyLatestInputState = new LatestInputState(
  new FolderPatternParams("", undefined),
  new GdriveParams(""),
  new MetadataParams("", "", undefined)
);

export const updateStoredInputData = (
  setInputData: (input: LatestInputState) => void,
  latestInputData: LatestInputState,
  inputData: FolderPatternParams | GdriveParams | MetadataParams
) => {
  switch (true) {
    case inputData instanceof FolderPatternParams:
      setInputData(
        new LatestInputState(
          inputData as FolderPatternParams,
          latestInputData.gdriveInput,
          latestInputData.metadataInput
        )
      );
      break;
    case inputData instanceof GdriveParams:
      setInputData(
        new LatestInputState(
          latestInputData.folderPatternInput,
          inputData as GdriveParams,
          latestInputData.metadataInput
        )
      );
      break;
    case inputData instanceof MetadataParams:
      setInputData(
        new LatestInputState(
          latestInputData.folderPatternInput,
          latestInputData.gdriveInput,
          inputData as MetadataParams
        )
      );
      break;
    default:
      console.error("Faulty input data type");
      break;
  }
};

export const getFolderPatternInputValue = (
  folderPattern: string | undefined,
  fileName: string | undefined
): FolderPatternParams => {
  return new FolderPatternParams(folderPattern, fileName);
};

export const getGdriveInputValue = (
  tagSearchQuery: string
): GdriveParams => {
  return new GdriveParams(tagSearchQuery);
};

export const getMetadataInputValue = (
  metaDataKey: string,
  metaDataValue: string,
  folder: string | undefined
): MetadataParams => {
  return new MetadataParams(metaDataKey, metaDataValue, folder);
};
